import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Control, DomUtil } from 'leaflet';
import { MapControl, withLeaflet } from 'react-leaflet';

class Legend extends MapControl {
  createLeafletElement(_props) {
    const riskValues = [
      {
        name: 'Low',
        className: 'risk-LOW',
      },
      {
        name: 'Medium',
        className: 'risk-MEDIUM',
      },
      {
        name: 'Med-High',
        className: 'risk-MEDIUM_HIGH',
      },
      {
        name: 'High',
        className: 'risk-HIGH',
      },

    ];

    const content = ([
      <h4>Rainfall amount</h4>,
      <ul>
        {riskValues.map((rv) => (
          <li key={rv.className} className={rv.className}>
            {rv.name}
          </li>
        ))}
      </ul>]
    );

    class LL extends Control {
      onAdd() {
        const l = DomUtil.create('div', 'legend');
        l.innerHTML = ReactDOMServer.renderToString(content);
        return l;
      }

      onRemove() {
      }
    }

    return new LL({ position: 'bottomright' }, _props.leafletElement);
  }
}

export default withLeaflet(Legend);
